import axios from 'axios'

const BASE_URL = import.meta.env.VITE_ERP_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api/v1'
const API_TIMEOUT = 10000

const api = axios.create({
  baseURL: BASE_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use((config) => {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_API_LOGS === 'true') {
    console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`)
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (import.meta.env.DEV) console.error('[API] Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export class SimpleApiService {
  getMode(): string {
    return 'django'
  }

  getBaseURL(): string {
    return BASE_URL
  }

  setAuthToken(_token: string) {
    // Tokens gérés via cookies httpOnly — rien à faire ici
  }

  removeAuthToken() {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('access_token')
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
  }

  async login(credentials: { username: string; password: string }) {
    try {
      const { data } = await api.post('/auth/login/', {
        username: credentials.username,
        password: credentials.password
      })
      if (data?.user) {
        localStorage.setItem('user', JSON.stringify(data.user))
      }
      return data
    } catch (error) {
      if (import.meta.env.DEV) console.error('[Auth] Erreur de connexion:', error)
      throw error
    }
  }

  async logout() {
    this.removeAuthToken()
    localStorage.removeItem('user')
  }

  async get(endpoint: string, config?: any) {
    const response = await api.get(endpoint, config)
    return response.data
  }

  async post(endpoint: string, data?: any, config?: any) {
    const response = await api.post(endpoint, data, config)
    return response.data
  }

  async put(endpoint: string, data?: any, config?: any) {
    const response = await api.put(endpoint, data, config)
    return response.data
  }

  async delete(endpoint: string, config?: any) {
    const response = await api.delete(endpoint, config)
    return response.data
  }
}

export const simpleApiService = new SimpleApiService()
export default api
